import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/thedigitalneighborhood.webp';
import screenshot_target from '../../../images/letterfunnel/jeanyvescharlier.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jean-Yves Charlier"
      firstname="Jean-Yves"
      companyname="The Digital Neighborhood"
      competition="Fellowmind en Conclusion"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeanyvescharlier.js